function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgInstructorNotes(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 49.425 56.3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.031 34.375h24.063a1.719 1.719 0 000-3.438H12.03c-.945 0-1.719.774-1.719 1.72 0 .945.774 1.718 1.72 1.718zm0-10.313h24.063c.945 0 1.718-.773 1.718-1.718 0-.946-.773-1.719-1.718-1.719H12.03c-.945 0-1.719.773-1.719 1.719 0 .945.774 1.718 1.72 1.718zm0 20.625h13.75a1.719 1.719 0 000-3.437h-13.75c-.945 0-1.719.773-1.719 1.719 0 .945.774 1.718 1.72 1.718zM41.25 0H6.875A6.874 6.874 0 000 6.875v41.25A6.874 6.874 0 006.875 55H41.25a6.874 6.874 0 006.875-6.875V6.875A6.878 6.878 0 0041.25 0zm3.438 48.125a3.442 3.442 0 01-3.438 3.438H6.875a3.442 3.442 0 01-3.438-3.438V13.75h41.25v34.375zm0-37.813H3.438V6.876a3.442 3.442 0 013.437-3.438H41.25a3.442 3.442 0 013.438 3.438v3.438z",
    id: _id
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.65 .65)",
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#B5B5B5",
    xlinkHref: "#".concat(_id)
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#3C3C3B",
    strokeWidth: 1.3,
    fill: "#76DAE7",
    xlinkHref: "#".concat(_id)
  })));
}
export default SvgInstructorNotes;